export default {

    userNameRules: [


        v => (v && v.length <= 25 && v.length >= 3) || 'กรอกข้อมูล 3 - 25 ตัวอักษร',
        v => /^(?=[a-zA-Z0-9._]{3,25}$)(?!.*[_.]{2})[^_.].*[^_.]$/.test(v) || "รูปแบบไม่ถูกต้อง"
    ],
    codeRules: [

        v => (v && v.length <= 5 && v.length >= 3) || 'กรอกข้อมูล 3 - 5 ตัวอักษร',
        v => Number.isInteger(Number(v)) || "ต้องเป็นตัวเลขเท่านั้น เช่น 001,100",
    ],
    URLRules: [
        v => /^([A-Za-z0-9_])\w+$/.test(v) || "รูปแบบไม่ถูกต้อง"
    ],
    orderRules: [
        v => /^\d{0,3}(?:\.\d{1,2})?$/.test(v) || "ต้องเป็นตัวเลขเท่านั้น เช่น 1,7 หรือมีทศนิยม 2 ตำแหน่ง เช่น 1.01, 5.15"
    ],
    emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail ไม่ถูกต้อง',
    ],
    textReqRules: [
        v => !!v || 'จำเป็นต้องระบุ (required)',
    ],
    multipleReqRules: [

        (v) => {
            if (!v || v.length < 1)
                return 'จำเป็นต้องระบุ (required)';
           /* else if (v.length > 0) {
                for (let i = 0; i < v.length; i++) {
                    if (v[i].length > 9)
                        return 'Invalid Number';
                }
            }*/
            else return true;
        }
    ],
    numRules: [
        v => Number.isInteger(Number(v)) || "ต้องเป็นตัวเลขเท่านั้น",
    ],


    fileSingleRules(size) {
        let sizeBytes = 0;
        sizeBytes = 1048576 * size
        return [
            value => !value || value.size < sizeBytes || 'ขนาดไฟล์ควรน้อยกว่า ' + size + ' MB!',

            // files => !files || !files.some(file => file.size > sizeBytes) || 'ขนาดไฟล์ควรน้อยกว่า '+size+' MB!'

        ]
    },
    fileMultiReqRules(size) {
        let sizeBytes = 0;
        sizeBytes = 1048576 * size
        return [
            files => !files || !files.some(file => file.size > sizeBytes) || 'ขนาดไฟล์ควรน้อยกว่า ' + size + ' MB!'

        ]
    }
}